import React, { useCallback, useEffect, useRef } from 'react';
import CrossOutInit from 'chameleon/packages/blue-book-player/CrossOut/CrossOutInit';
import CrossOutInjector from 'chameleon/packages/blue-book-player/CrossOut/CrossOutInjector';
import QuestionCrossOutInjector from 'chameleon/packages/blue-book-player/CrossOut/QuestionCrossOutInjector';
import useCrossOut from 'chameleon/packages/blue-book-player/CrossOut/hooks/useCrossOut';
import TwoColumnInjector from 'chameleon/packages/blue-book-player/InnerContainer/TwoColumnInjector';
import QuestionLayout from 'chameleon/packages/blue-book-player/InnerContainer/QuestionLayout';
import SharedPassageInfoInit from 'chameleon/packages/blue-book-player/InnerContainer/SharedPassageInfoInit';
import ContentTabsInjector from 'chameleon/packages/blue-book-player/InnerContainer/ContentTabsInjector';
import { isMobile } from 'chameleon/packages/blue-book-player/mobile/utils';
import useDisableCopyQuestions from 'chameleon/packages/blue-book-player/hooks/useDisableCopyQuestions';
import HighlightsNotesWrapper from 'chameleon/packages/blue-book-player/library/HighlightsNotesWrapper';
import QuestionContentWrapper from 'chameleon/packages/blue-book-player/InnerContainer/QuestionContentWrapper';
import useProcessAnchors from 'chameleon/packages/blue-book-player/hooks/useProcessAnchors';
import ToolbarManager from '../ToolbarManager';
import ReviewPage from '../ReviewPage';

const InnerContainer = (props) => {
  const {
    children,
    learnosityApp,
    isReviewPage,
    isStudentAccount,
    isSingleQuestionPreview,
    previewData,
    subject,
    userData,
    playerState,
    bluebookUiHighlightEnabled,
    isSecure,
  } = props;
  const crossOutReducer = useCrossOut(learnosityApp);
  const learnosityItemsRef = useRef([]);

  useDisableCopyQuestions(playerState, learnosityApp);
  useProcessAnchors(playerState, learnosityApp);

  useEffect(() => {
    learnosityItemsRef.current = Object.keys(learnosityApp?.getItems() || {});
  }, [learnosityApp]);

  const renderContent = useCallback(
    ({ isQuestionDisplayed, setIsQuestionDisplayed }) => (
      <>
        {isMobile ? (
          <ContentTabsInjector
            learnosityApp={learnosityApp}
            learnosityItemsRef={learnosityItemsRef}
          />
        ) : (
          <TwoColumnInjector
            learnosityApp={learnosityApp}
            crossOutReducer={crossOutReducer}
            setIsQuestionDisplayed={setIsQuestionDisplayed}
          />
        )}
        {bluebookUiHighlightEnabled && (
          <HighlightsNotesWrapper
            learnosityApp={learnosityApp}
            playerState={playerState}
            isStudentAccount={isStudentAccount}
            isQuestionDisplayed={isQuestionDisplayed}
            subject={subject}
          />
        )}
      </>
    ),
    [learnosityApp, crossOutReducer, playerState, isStudentAccount],
  );

  return (
    <div
      className="bluebook-player-inner-container w-full grow shrink basis-auto relative"
      data-cy="middle"
    >
      {children}
      {isReviewPage && <ReviewPage learnosityApp={learnosityApp} />}
      <QuestionContentWrapper renderContent={renderContent} />
      <QuestionLayout learnosityApp={learnosityApp} />
      <CrossOutInit
        learnosityApp={learnosityApp}
        crossOutReducer={crossOutReducer}
      />
      <CrossOutInjector
        learnosityApp={learnosityApp}
        crossOutReducer={crossOutReducer}
        isSingleQuestionPreview={isSingleQuestionPreview}
        isStudentAccount={isStudentAccount}
        previewData={previewData}
        learnosityItemsRef={learnosityItemsRef}
      />
      <QuestionCrossOutInjector
        learnosityApp={learnosityApp}
        crossOutReducer={crossOutReducer}
        isStudentAccount={isStudentAccount}
      />
      <ToolbarManager
        learnosityApp={learnosityApp}
        subject={subject}
        userData={userData}
        isSecure={isSecure}
      />
      {!isSingleQuestionPreview && (
        <SharedPassageInfoInit learnosityApp={learnosityApp} />
      )}
      <div className="modal-inner-root" />
    </div>
  );
};

export default InnerContainer;
